import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeIcon from '@mui/icons-material/Home';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const NotFound: FC = () => {
  const navigate = useNavigate();

  const handleBackClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h1">404</Typography>

      <Typography variant="h3" sx={{ mb: 2 }}>
        Šitokio puslapio nėra
      </Typography>

      <Box>
        <Button
          onClick={handleBackClick}
          startIcon={<ArrowBackIosIcon />}
          variant="contained"
          sx={{ mr: 1 }}>
          Atgal
        </Button>

        <Button href="/" startIcon={<HomeIcon />} variant="contained">
          Pradžia
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
